import { jsx as d } from "react/jsx-runtime";
import { createContext as c, useContext as v, useState as l } from "react";
import { createEventEmitter as N } from "@made-people/grease-event-emitter";
import { toEmailAddressOrUndefined as h } from "@made-people/types-email-address";
const w = c(void 0), M = (e) => /* @__PURE__ */ d(w.Provider, { value: e, children: e.children }), x = () => {
  const e = v(w);
  return e || { additionalData: void 0 };
}, C = N(), E = c(
  void 0
), D = (e) => {
  const n = e.newsletterEventEmitter ?? C, o = {
    newsletterClient: e.newsletterClientDriver,
    newsletterEventEmitter: n
  };
  return /* @__PURE__ */ d(E.Provider, { value: o, children: e.children });
};
D.displayName = "NewsletterProvider";
const P = () => {
  const e = v(E);
  if (!e)
    throw new Error("useNewsletter must be used within a NewsletterProvider");
  return e;
}, S = (e) => {
  const { newsletterClient: n, newsletterEventEmitter: o } = P(), { additionalData: m } = x(), [u, s] = l(!1), [f, r] = l(void 0);
  return {
    loading: u,
    error: f,
    setError: r,
    execute: async (i) => {
      if (r(void 0), h(i.email) === void 0) {
        const t = new Error("Newsletter_Method_InvalidEmail");
        throw r(t), t;
      }
      s(!0);
      try {
        await n[e](i), o.emit(e, {
          payload: i,
          additionalData: m
        });
      } catch (t) {
        const a = t instanceof Error ? t : new Error(`${t}`);
        throw r(a), a;
      } finally {
        s(!1);
      }
    }
  };
};
export {
  M as NewsletterEventAdditionalDataProvider,
  D as NewsletterProvider,
  C as newsletterEventEmitter,
  P as useNewsletter,
  x as useNewsletterEventAdditionalData,
  S as useNewsletterMethod
};
